import React from 'react';
import {useTranslation} from 'react-i18next';
import {formatPct, formatRoas} from '../panel_v11/economyFormatters';
import {UNLOCK_READY} from './state/economiaModel';

/**
 * «Con lo que cargaste, ya tienes» (mockup 2): cada dato que se completa enciende una respuesta más.
 * Las filas las arma `unlocksFor` (espejo de las fórmulas del backend) y se recalculan al tipear:
 * es la respuesta inmediata del formulario, no el número que se guarda.
 */
export function EconomiaUnlocks({rows}) {
    const {t} = useTranslation();

    const valueText = (row) => {
        if (row.kind === 'roas') return formatRoas(row.value) || '—';
        if (row.kind === 'pct') return formatPct(row.value) || '—';
        return undefined;
    };

    return (
        <section className="eco-fs eco-unlocks" aria-labelledby="eco-unlocks-title" data-testid="eco-unlocks">
            <div className="eco-fs__head">
                <h2 className="eco-fs__title" id="eco-unlocks-title">{t('economics.form.section_unlocks')}</h2>
            </div>
            <ul className="eco-unlocks__list">
                {rows.map((row) => {
                    const ready = row.status === UNLOCK_READY;
                    return (
                        <li className="eco-unlocks__row" key={row.key} data-testid={`eco-unlock-${row.key}`}
                            data-status={row.status}>
                            <span className={`eco-unlocks__tag ${ready ? '-ready' : '-pending'}`}>
                                {t(ready ? 'economics.unlock.ready' : 'economics.unlock.pending')}
                            </span>
                            <span className="eco-unlocks__txt">
                                {/* El plural del tope («Falta 1 día» / «Faltan 5 días») lo elige `count`. */}
                                {t(row.textKey, {value: valueText(row), count: row.days,
                                    interpolation: {escapeValue: false}})}
                            </span>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}

export default EconomiaUnlocks;
